"use strict";import{tag as i}from"../custom-tag.js";export function ceCreditsIcon({height:r=16,width:t=16,hidden:e=!1,title:l="Ce credits"}={}){return i`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${t}
      height=${r}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${e?"true":"false"}"
      role="img"
      aria-label="${l}"
    >
      <circle
        cx="12"
        cy="12"
        r="10.5"
        fill="transparent"
        stroke="currentColor"
        stroke-width="3"
      />
      <path
        fill="currentColor"
        d="M9.306 14.836q.93 0 1.53-.59a1.82 1.82 0 0 0 .56-1.24h1.03a2.64 2.64 0 0 1-.44 1.32 2.9 2.9 0 0 1-1.09.98q-.73.39-1.61.39-1.629 0-2.52-1.11-.78-.981-.78-2.64 0-1.9 1.07-2.91.891-.84 2.31-.84 1.35 0 2.24.83.741.68.81 1.63h-1.03q-.1-.79-.71-1.23-.54-.38-1.31-.38-1.149 0-1.77.82-.57.75-.57 2.08 0 1.46.72 2.24.6.65 1.56.65m8.466-3.37v.84h-3.18v2.38h3.47v.86h-4.49v-7.2h4.49v.86h-3.47v2.26z"
      />
    </svg>
  `}
//# sourceMappingURL=ceCredits.js.map
